import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getFentraLog = api(async function fentraLog({ profileId, limit } = {}) {
    return await query(
        gql`
            query fentraLog($profileId: ID!, $limit: Int) {
                fentraLog(profileId: $profileId, limit: $limit) {
                    _id
                    profileId
                    timestamp
                    method
                    path
                    status
                    durationMs
                    ok
                    detail
                }
            }
        `,
        { profileId, limit },
        { returns: "fentraLog" }
    )
})
